const websiteFR = 'https://batch.loccitane.com/immortelle-reset_relaunch_travel_retail,29,2,94856,1334348.htm';
const websiteCN = 'https://batch.loccitane.com/immortelle-reset_relaunch_travel_retail,29,3,94856,1334348.htm';
const originalWebsite = 'https://batch.loccitane.com/immortelle-reset_relaunch_travel_retail,29,1,94856,1334348.htm';

function redirectTo(website) {
  window.location.href = website;
}

function switchCountry() {
  const customerLanguage = navigator.language.split('-')[0];

  switch (customerLanguage) {
    default: break;

    case 'fr':
      redirectTo(websiteFR);
      break;

    case 'cn':
    case 'zh':
      redirectTo(websiteCN);
      break;
  }
}

function init() {
  if (OCMS.GlobalVars.C === 29 && window.location.href === originalWebsite) {
    switchCountry();
  }
}

export default init;

export {
  init
};



// WEBPACK FOOTER //
// ./js/generic/qr_travel_retail/qr_travel_retail.js